<template>
  <div class="">
    <el-row class="tac">
      <el-menu :default-active="$store.state.loaction" router class="el-menu-vertical-demo" background-color="#112955" text-color="#fff" unique-opened active-text-color="#fff" @select="handleSelect" style="height:100%;overflow: hidden;border-right:0px;">
        <el-menu-item index="/home">
          <i class="el-icon-menu  iconfont icon-home1"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-submenu index="模板设置" v-show="(!UseSimpleView)&&TemplateSetting">
          <template slot="title">
            <i class="el-icon-location  iconfont icon-fuzhi"></i>
            <span>模板设置</span>
          </template>
          <el-menu-item index="/templates/subcommissiontemplates">客户手续费模板</el-menu-item>
          <el-menu-item index="/templates/agentfeetemplates" v-show="AgentFeeTemplatesIsShow">代理手续费模板</el-menu-item>
        </el-submenu>
        <!-- <el-menu-item index="/selects/todayreports">
          <i class="el-icon-location iconfont icon-Account"></i>
          <span slot="title">我的客户</span>
        </el-menu-item> -->
         <el-submenu index="我的客户">
                <template slot="title">
                  <i class="el-icon-location iconfont icon-Account"></i>我的客户</template>
                <el-menu-item index="/selects/todayreports">当日查询</el-menu-item>
                <el-menu-item index="/subaccounts" v-show="(!UseSimpleView)&&DirectlyCustomer">我的直属客户</el-menu-item>
              </el-submenu>
        <el-menu-item index="/agents" v-show="(!UseSimpleView)&&LowerAgent">
          <template slot="title">
            <i class="el-icon-location iconfont icon-user-agent"></i>
            <span>下级代理</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/agentAccounts" v-show="SubAccount&&(($store.state.userInfo.AccountCode == '' || $store.state.userInfo.AccountCode != $store.state.userInfo.UserCode) ? false : true) && !UseSimpleView" id="agentAccount">
          <template slot="title">
            <i class="el-icon-location iconfont icon-user"></i>
            <span>代理子管理账户</span>
          </template>
        </el-menu-item>
        <el-submenu index="数据查询">
          <template slot="title">
            <i class="el-icon-location iconfont icon-fangdajing"></i>
            <span>数据查询<el-badge is-dot class="item" v-show="$store.state.whetherNewNoticeCharge" /></span>
          </template>
          <el-menu-item index="/selects/accountreports" v-show="SubAccountLimit && !UseSimpleView">我的账户查询</el-menu-item>
          <el-menu-item index="/selects/clientreports" >客户查询</el-menu-item>
          <!-- <el-menu-item index="/selects/todayreports">当日查询</el-menu-item> -->
          <el-menu-item index="/selects/noticeAgents">代理通知<el-badge value="new" class="item" :hidden="!$store.state.whetherNewNoticeCharge" /></el-menu-item>
          <el-menu-item index="/selects/insstationmessage">站内信</el-menu-item>
        </el-submenu>
        <el-menu-item index="/selects/exportdown">
          <template slot="title">
            <i class="el-icon-location iconfont icon-user-agent"></i>
            <span>报表导出</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/personaldata" v-show="!UseSimpleView">
          <template slot="title">
            <i class="el-icon-location iconfont icon-user-agent"></i>
            <span>个人信息</span>
          </template>
        </el-menu-item>

      </el-menu>
    </el-row>
    <div class="asdielinetop"></div>
    <div class="asdielinebottom"></div>
  </div>
</template>

<script>
import "../assets/lib/jquery.min.js";
export default {
  //
  name: "asides",
  data() {
    return {
      type: "",
      aa: "",
      userInfo: {},
      SubAccountLimit: true,
      AgentFeeTemplatesIsShow: true,
      UseSimpleView:false,
      TemplateSetting:false,
      LowerAgent:false,
      SubAccount:false,
      DirectlyCustomer:false
    };
  },
  created() {
    if (sessionStorage.getItem("UseSimpleView") != null){
      this.UseSimpleView = JSON.parse(sessionStorage.getItem("UseSimpleView"));
    }

    if(sessionStorage.getItem("TemplateSetting")!= null){
        this.TemplateSetting=JSON.parse(sessionStorage.getItem("TemplateSetting"));
    }
     if(sessionStorage.getItem("LowerAgent")!= null){
        this.LowerAgent=JSON.parse(sessionStorage.getItem("LowerAgent"));
    }
    if(sessionStorage.getItem("SubAccount")!= null){
        this.SubAccount=JSON.parse(sessionStorage.getItem("SubAccount"));
    }
    if(sessionStorage.getItem("DirectlyCustomer")!= null){
        this.DirectlyCustomer=JSON.parse(sessionStorage.getItem("DirectlyCustomer"));
    }






    this.type = JSON.parse(sessionStorage.getItem("type"));
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (
      this.$route.path.indexOf("login") != -1 ||
      this.$route.path.indexOf("forgetPswd") != -1 ||
      this.$route.path.indexOf("iphonregister") != -1
    ) {
      this.$store.state.userInfo.AccountCode = "";
    } else {
      this.$store.state.userInfo.AccountCode = this.userInfo.AccountCode;
      this.$store.state.userInfo.UserCode = this.userInfo.UserCode;
    }
  },
  watch: {
    "$route": "getSubAccountLimit"
  },
  methods: {
    getSubAccountLimit(){
      this.SubAccountLimit = true;
      if (sessionStorage.getItem("type") == "1"){
        if (sessionStorage.getItem("SubAccountLimit") != null && sessionStorage.getItem("SubAccountLimit") != "undefined" && sessionStorage.getItem("SubAccountLimit") != undefined) {
          this.SubAccountLimit = JSON.parse(sessionStorage.getItem("SubAccountLimit"));
        }
      }
      // console.log(this.SubAccountLimit,sessionStorage.getItem("type"));
    },
    handleSelect(key, keyPath, text) {
      this.$store.state.agentstate = "";
      this.$store.state.breadnav2 = text.$el.innerText;
      if (keyPath[0].length > 5) {
        this.$store.state.breadnav1 = 0;
      } else if (keyPath[0] == "/home") {
        this.$store.state.breadnav1 = 0;
        this.$store.state.breadnav2 = 0;
      } else {
        this.$store.state.breadnav1 = keyPath[0];
      }
    }
  }
};
</script>

<style scoped>
.fa {
  padding-left: 5px;
  margin-right: 10px;
}
.tac {
  background-color: #112955;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/aside.vue